import React, { useRef } from 'react';
import Button from '@material-ui/core/Button';
import SarasHotKeys from '../../../notifications/SarasHotKeys'
import { Icon } from '../../../decor/SarasIcons';
import { IconButton } from '@material-ui/core';

const SarasButton=(props)=>{
    const { id,disabled,onClick,className,style,text,size, starIcon, endIcon, 
        starIconClassName, endIconClassName,
        onlyIcon,tooltip,viewSwitch,
        startIconStyle,
        children,variant,fullWidth,actionv, ksc } = props
    const btn = useRef();

    const onButtonClick = (e) => {
        if(onClick) onClick(e, viewSwitch);
    }

    const onHotkeyPress = (e) => {
        onButtonClick(btn, viewSwitch);
    }

    const BtnStarIcon = Icon[starIcon];
    const BtnEndIcon = Icon[endIcon];

    if(onlyIcon) {
        return (
            <SarasHotKeys ksc={ksc} onHotKey={onHotkeyPress} tooltip={tooltip}>
                <IconButton component="span"
                    ref={btn}
                    disabled={disabled}
                    size={size || "small"}
                    classes={{ disabled: 'uiDisabledIconButton' }}
                    className={`${className} uiOnlyIconShowing`} onClick={onButtonClick} >
                    <BtnStarIcon 
                        className={`${starIconClassName || 'uiDefaultIconButton'} ${disabled ? 'uiDisabledIconButton' : ''}`}
                        style={startIconStyle}
                    />
                    {/* {text || children} */}
                </IconButton>
            </SarasHotKeys>
        );
    }

    return(
        <SarasHotKeys ksc={ksc} onHotKey={onHotkeyPress} tooltip={tooltip}>
            <Button ref={btn} type={props.type} id={id} disabled={disabled} fullWidth={fullWidth} variant={variant || 'contained'} 
                color={props.color} className={className || "uiContentCenter uiButtonAppText2"} onClick={onButtonClick} 
                classes={{ disabled: 'uiDisabledIconButton' }}
                style={style} actionv={actionv}
                size={size || "small"}
                startIcon={
                    BtnStarIcon ? 
                <BtnStarIcon 
                    className={`${starIconClassName || 'uiBrandColor1'} ${disabled ? 'uiDisabledIconButton' : ''}`}
                    style={startIconStyle}
                  /> : null
                }
                endIcon={
                BtnEndIcon ? <BtnEndIcon 
                    className={`${endIconClassName || 'uiDefaultIconButton'} ${disabled ? 'uiDisabledIconButton' : ''}`}
                  /> : null
                }
            >
                <span className='uiAppText2Compliment'>
                    {text || children}
                </span>
            </Button>
        </SarasHotKeys>
    )
}

export default SarasButton